import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';
import { delay, finalize } from 'rxjs';
//TODO
export const SpinnerDisabledUrls: string[] = [
  'icons'
]
export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('icons')) {
    return next(req);
  } else {
    const spinnerService = inject(SpinnerService)
    spinnerService.startRequest();
    return next(req).pipe(finalize(() => {
      spinnerService.completeRequest();
    })
    );
  }
};
